import { getEmptySection, Section } from './section.model';

export interface Template {
  id: string;
  name: string;
  nameInitial: boolean;
  type: TemplateType;
  version: number;
  schemaVersion: number;
  documentVersion: string;
  wordTemplate: string;
  documentTitle: string;
  lastModified: Date;
  sections?: Section[];
}

export function getEmptyTemplate(): Template {
  return {
    id: '',
    name: '',
    nameInitial: false,
    type: TemplateType.HYGIENE_PLAN,
    version: 0,
    schemaVersion: 0,
    documentVersion: '',
    lastModified: new Date(),
    wordTemplate: '',
    documentTitle: '',
    sections: [getEmptySection()],
  };
}

export enum TemplateType {
  CERTIFICATE = 'CERTIFICATE',
  HYGIENE_PLAN = 'HYGIENE_PLAN',
}
